import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M14.14 4.09s-.201-3.6 2.057-2.327c2.259 1.272-5.164 6.017-3.534 6.413 1.631.395 2.953.192 2.953.192"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M18.667 2.708s-4.013 4.18-2.023 4.265c1.99.086 3.173-.764 3.173-.764"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M18.867 5.42s-1.299 1.792-1.275 3.382"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="m17.799 11.473-1.02 9.21a2 2 0 0 1-2.208 1.768l-7.938-.879a2 2 0 0 1-1.768-2.207L6.549 4.143a2 2 0 0 1 2.208-1.768l3.225.357"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.2}
      d="m5.043 17.753 11.914 1.319"
    />
    <circle
      cx={10.889}
      cy={20.1}
      r={0.466}
      fill="currentColor"
      transform="rotate(6.315 10.889 20.1)"
    />
  </svg>
);
export const Phone247Icon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
